module.exports = __webpack_public_path__ + "img/error-403.svg";